import script from "./AttendanceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceListView.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceListView.vue?vue&type=style&index=0&id=7d4562cd&lang=css"

const __exports__ = script;

export default __exports__